module.exports = __webpack_public_path__ + "c593ec423bb60d8f1dfb05d77f0033ff.png";